"use client";

import { cva, type VariantProps } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import {
  BaseDialog,
  BaseDialogBackdrop,
  BaseDialogClose,
  BaseDialogDescription,
  BaseDialogHeader,
  BaseDialogPopup,
  BaseDialogTitle,
  BaseDialogTrigger,
  type DialogPrimitive,
} from "./dialog";
import type { DialogDescriptionProps, DialogParts } from ".";

// Con Edison Dialog Content
const conEdisonDialogContentVariants = cva({
  base: "rounded-none!",
});

function ConEdisonDialogContent({
  className,
  ...props
}: DialogPrimitive.Popup.Props &
  VariantProps<typeof conEdisonDialogContentVariants>) {
  return (
    <BaseDialogPopup
      {...props}
      className={cn(
        conEdisonDialogContentVariants({
          className,
        }),
      )}
    />
  );
}

// Con Edison Dialog Header
const conEdisonDialogHeaderVariants = cva({
  base: "text-left",
});

function ConEdisonDialogHeader({
  className,
  ...props
}: DialogPrimitive.Popup.Props) {
  return (
    <BaseDialogHeader
      {...props}
      className={cn(
        conEdisonDialogHeaderVariants({
          className,
        }),
      )}
    />
  );
}

// Con Edison Dialog Title
const conEdisonDialogTitleVariants = cva({
  // base: ["font-semibold", lexend.className], // TODO: add lexend.className once available in this package
  base: ["font-semibold"],
});

function ConEdisonDialogTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <BaseDialogTitle
      {...props}
      className={cn(
        conEdisonDialogTitleVariants({
          className,
        }),
      )}
    />
  );
}

// Con Edison Dialog Description
const conEdisonDialogDescriptionVariants = cva({
  base: "text-inherit",
});

function ConEdisonDialogDescription({
  className,
  ...props
}: DialogDescriptionProps) {
  return (
    <BaseDialogDescription
      {...props}
      className={cn(
        conEdisonDialogDescriptionVariants({
          className,
        }),
      )}
    />
  );
}

export const conEdisonDialogKit: DialogParts = {
  Root: BaseDialog,
  Trigger: BaseDialogTrigger,
  Portal: ConEdisonDialogContent,
  Close: BaseDialogClose,
  Backdrop: BaseDialogBackdrop,
  Popup: BaseDialogPopup,
  Header: ConEdisonDialogHeader,
  Title: ConEdisonDialogTitle,
  Description: ConEdisonDialogDescription,
};
